export default __webpack_public_path__ + "media/images/features/local_delivery/episode1/LP_06-d20ebb7f8231a7f08f5825cc3c87cb6c.jpg";